import { Home, Truck, BarChart3, Shield, ClipboardCheck, Wrench, Route, FileText, Settings, LogOut } from 'lucide-react'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { Button } from '@/components/ui/button'

const menuItems = [
  { title: 'Dashboard', icon: Home, url: '/' },
  { title: 'Fleet', icon: Truck, url: '/fleet' },
  { title: 'Analytics', icon: BarChart3, url: '/analytics' },
  { title: 'Safety', icon: Shield, url: '/safety' },
  { title: 'Compliance', icon: ClipboardCheck, url: '/compliance' },
  { title: 'Maintenance', icon: Wrench, url: '/maintenance' },
  { title: 'Routing', icon: Route, url: '/routing' },
  { title: 'Reports', icon: FileText, url: '/reports' },
  { title: 'Settings', icon: Settings, url: '/settings' },
]

export function AppSidebar() {
  const location = useLocation()
  const navigate = useNavigate()
  const { logout, user } = useAuth()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <Sidebar>
      <SidebarContent>
        {/* Logo/Header */}
        <div className="px-6 py-4 border-b">
          <h2 className="text-xl font-bold text-primary">FleetVision</h2>
          <p className="text-xs text-muted-foreground">Fleet Management</p>
        </div>

        {/* Navigation */}
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarMenu>
            {menuItems.map((item) => {
              const isActive = location.pathname === item.url
              return (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <Link
                      to={item.url}
                      className={isActive ? 'bg-accent text-accent-foreground' : ''}
                    >
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              )
            })}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>

      {/* Footer with User Info and Logout */}
      <div className="mt-auto border-t p-4">
        <div className="flex items-center justify-between">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium truncate">{user?.name || 'User'}</p>
            <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleLogout}
            className="shrink-0"
            title="Logout"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </Sidebar>
  )
}
